import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'numberOrDefault'
})
export class NumberOrDefaultPipe implements PipeTransform {

  public transform(value: number | string): number {
    const result = (!value || isNaN(value as number) || !Number.isFinite(value)) ? 0 : value as number;
    return result;
  }
}
